// import React, { useState } from "react";
// import "../../Assets/scss/pages/security.scss";
// import DashboardPagesTemplate from "../../Template/DashboardPagesTemplate";
// import DashboardPageTitle from "../../Components/InnerPageTitle";
// import { useTranslation } from "react-i18next";
// import TwoFactorStatus from "../../Components/GoogleAuthenticator/TwoFactorStatus";
// import UpdatePassword from "../../Components/Profile/UpdatePassword";
// import IPAddressSection from "../../Components/TrustedIPManager/IPAddressSection";
// // import { useSelector } from "react-redux";
// // import { StoreProptypes } from "../../PropTypes/StoreProptypes";

// const SecurityPage: React.FC = () => {
//   const { t } = useTranslation();
//   // const { user } = useSelector((store: StoreProptypes) => store);
//   // Determine which tabs to show based on user parent_id
//   // const tabList =
//   //   user?.parent_id === 0 || user?.parent_id === 1
//   //     ? [t("Two-factor authentication"), t("IP Address"), t("Change Password")]
//   //     : [t("Two-factor authentication"), t("Change Password")];

//   // const [activeTab, setActiveTab] = useState<string>(tabList[0]);
//   // const renderContent = () => {
//   //   switch (activeTab) {
//   //     case t("Two-factor authentication"):
//   //       return <TwoFactorStatus />;
//   //     case t("IP Address"):
//   //       return <IPAddressSection userId={""} />;
//   //     case t("Change Password"):
//   //       return (
//   //         <div className="aioa-dashboard-profile-content">
//   //           <UpdatePassword />
//   //         </div>
//   //       );
//   //     default:
//   //       return null;
//   //   }
//   // };

//   return (
//     <DashboardPagesTemplate>
//       <DashboardPageTitle
//         pageTitle={t("security")}
//         subPageTitle={t("Update your security information")}
//       />
//       <div className="d-flex flex-column flex-lg-row justify-content-between gap-3">
//         <TwoFactorStatus />
//         <IPAddressSection userId={""} />
//       </div>
//       <div className="aioa-dashboard-profile-content">
//         <UpdatePassword />
//       </div>
//     </DashboardPagesTemplate>
//   );
// };

// export default SecurityPage;


import React, { useState } from "react";
import "../../Assets/scss/pages/security.scss";
import DashboardPagesTemplate from "../../Template/DashboardPagesTemplate";
import DashboardPageTitle from "../../Components/InnerPageTitle";
import { useTranslation } from "react-i18next";
import TwoFactorStatus from "../../Components/GoogleAuthenticator/TwoFactorStatus";
import UpdatePassword from "../../Components/Profile/UpdatePassword";
import IPAddressSection from "../../Components/TrustedIPManager/IPAddressSection";
// import { useSelector } from "react-redux";
// import { StoreProptypes } from "../../PropTypes/StoreProptypes";

const SecurityPage: React.FC = () => {
  const { t } = useTranslation();
  // const { user } = useSelector((store: StoreProptypes) => store);
  
  // Tab configuration - all three tabs shown
  const tabList = [
    t("Two-factor authentication"), 
    t("IP Address"), 
    t("Change Password")
  ];
  
  const [activeTab, setActiveTab] = useState<string>(tabList[0]);

  const renderContent = () => {
    switch (activeTab) {
      case t("Two-factor authentication"):
        return <TwoFactorStatus />;
      case t("IP Address"):
        return <IPAddressSection userId={""} />;
      case t("Change Password"):
        return (
          <div className="aioa-dashboard-profile-content">
            <UpdatePassword />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <DashboardPagesTemplate>
      <DashboardPageTitle
        pageTitle={t("security")}
        subPageTitle={t("Update your security information")}
      />
      
      <div className="security-tabs">
        <ul className="tab-header">
          {tabList.map((tab) => (
            <li
              key={tab}
              className={activeTab === tab ? "active" : ""}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </li>
          ))}
        </ul>
        <div className="tab-body">
          <div className="tab-content">
            {renderContent()}
          </div>
        </div>
      </div>
    </DashboardPagesTemplate>
  );
};

export default SecurityPage;